import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { Contact } from '../models/contact.model';
import { Activity } from '../models/activity.model';

@Injectable({ providedIn: 'root' })
export class ContactService {
  private apiUrl = environment.apiUrl + '/Contact';

  http = inject(HttpClient);

  getContacts(): Observable<Contact[]> {
    return this.http.get<Contact[]>(`${this.apiUrl}/GetContacts`);
  }

  getContactById(contactId: number): Observable<Contact> {
    return this.http.get<Contact>(`${this.apiUrl}/GetContactById/${contactId}`);
  }

  updateContact(contactId: number, contact: Contact): Observable<boolean> {
    return this.http.put<boolean>(`${this.apiUrl}/UpdateContact/${contactId}`, contact);
  }

  deleteContact(contactId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/DeleteContact/${contactId}`);
  }

  saveContact(contact: Contact): Observable<Activity> {
    return this.http.post<Activity>(`${this.apiUrl}/CreateContact`, contact);
  }
}
